import React, { useEffect, useState } from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";
import { useDispatch, useSelector } from "react-redux";
import { addToWishlist } from "../features/products/productSlilce";
import { getuserProductWishlist } from "../features/user/userSlice";
import { useNavigate } from "react-router-dom";
import { symbole } from "../components/commonData";
import DataNotFound from "../components/DataNotFound";
import ApiResponseModal from "../components/ApiResponseModal";

const Wishlist = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [apiModal, setApiModal] = useState({
  show: false,
  type: "success",
  title: "",
  message: "",
});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getuserProductWishlist());
  }, []);

  const wishlistState = useSelector(
    (state) => state?.auth?.wishlist?.wishlist
  );

const removeFromWishlist = async (id) => {
  try {
    const resultAction = await dispatch(addToWishlist(id));

    // ✅ Success
    if (addToWishlist.fulfilled.match(resultAction)) {
      setApiModal({
        show: true,
        type: "success",
        title: "Removed from Wishlist",
        message: "Product removed from your wishlist successfully",
      });

      dispatch(getuserProductWishlist()); // ✅ no timeout
    }

    // ❌ Rejected
    if (addToWishlist.rejected.match(resultAction)) {
      setApiModal({
        show: true,
        type: "error",
        title: "Failed",
        message:
          resultAction.error?.message ||
          "Unable to remove product from wishlist",
      });
    }
  } catch (err) {
    setApiModal({
      show: true,
      type: "error",
      title: "Error",
      message: "Something went wrong. Please try again.",
    });
  }
};

  const paginatedOrders = wishlistState
    ? [...wishlistState].reverse().slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      )
    : [];

  const totalPages = wishlistState
    ? Math.ceil(wishlistState.length / itemsPerPage)
    : 0;

  return (
    <>
            <ApiResponseModal
  show={apiModal.show}
  type={apiModal.type}
  title={apiModal.title}
  message={apiModal.message}
  onClose={() =>
    setApiModal((prev) => ({ ...prev, show: false }))
  }
/>
      <Meta title={"Wishlist"} />
      <BreadCrumb title="Wishlist" />

      {/* ✅ INLINE CSS (SAME FILE) */}
      <style>{`
        .wishlist-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 14px;
        }

        @media (min-width: 768px) {
          .wishlist-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        @media (min-width: 1200px) {
          .wishlist-grid {
            grid-template-columns: repeat(4, 1fr);
          }
        }

        .wishlist-card {
          background: #fff;
          border-radius: 14px;
          overflow: hidden;
          position: relative;
          box-shadow: 0 6px 20px rgba(0,0,0,0.08);
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }

        .wishlist-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 28px rgba(0,0,0,0.12);
        }

        .wishlist-remove {
          position: absolute;
          top: 8px;
          right: 8px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: rgba(255,255,255,0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 2;
        }

        .wishlist-remove img {
          width: 14px;
        }

        .wishlist-img-wrapper {
          width: 100%;
          aspect-ratio: 1 / 1;
          overflow: hidden;
          cursor: pointer;
        }

        .wishlist-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .wishlist-info {
          padding: 10px 12px;
          cursor: pointer;
        }

        .wishlist-title {
          font-size: 14px;
          font-weight: 600;
          line-height: 1.4;
          margin-bottom: 4px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .wishlist-price {
          font-size: 15px;
          font-weight: 700;
          color: #0d6efd;
        }

        @media (max-width: 576px) {
          .wishlist-title {
            font-size: 13px;
          }
          .wishlist-price {
            font-size: 14px;
          }
        }
      `}</style>

      {paginatedOrders?.length > 0 ? (
        <Container class1="wishlist-wrapper home-wrapper-2 py-4">
          <div className="wishlist-grid">
            {paginatedOrders.map((item, index) => (
              <div className="wishlist-card" key={index}>
                
                {/* ❌ Remove */}
                <div
                  className="wishlist-remove"
                  onClick={() => removeFromWishlist(item?._id)}
                >
                  <img src="images/cross.svg" alt="remove" />
                </div>

                {/* Image */}
                <div
                  className="wishlist-img-wrapper"
                  onClick={() => navigate("/product/" + item?._id)}
                >
                  <img
                    src={
                      item?.images?.[0]?.url ||
                      "images/watch.jpg"
                    }
                    alt={item?.title}
                    className="wishlist-img"
                  />
                </div>

                {/* Info */}
                <div
                  className="wishlist-info"
                  onClick={() => navigate("/product/" + item?._id)}
                >
                  <div className="wishlist-title">
                    {item?.title}
                  </div>
                  <div className="wishlist-price">
                    {symbole} {item?.price}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-4">
              <ul className="pagination pagination-sm">
                {[...Array(totalPages)].map((_, i) => (
                  <li
                    key={i}
                    className={`page-item ${
                      currentPage === i + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Container>
      ) : (
        <DataNotFound />
      )}
    </>
  );
};

export default Wishlist;
